<div class="container flex flex-row gap-[10px] justify-start items-start">
  <mat-icon>cancel</mat-icon>
  <div class="flex flex-col gap-[4px] justify-start items-start">
    <vi-text weight="bold">
      {{ '+INSTALLATIONS.INSTALLATION.ERROR_LIST.LOCKED_SYSTEM_ERROR.TITLE' | translate }}
    </vi-text>
    <vi-text *ngIf="installationDetailsStore.isMainDeviceHeatPump$ | async">
      {{ '+INSTALLATIONS.INSTALLATION.ERROR_LIST.LOCKED_SYSTEM_ERROR.DESCRIPTION' | translate }}
    </vi-text>
    <vi-text *ngIf="installationDetailsStore.isMainDeviceBoiler$ | async">
      {{
        '+INSTALLATIONS.INSTALLATION.ERROR_LIST.LOCKED_SYSTEM_ERROR.GAS_BOILER_DESCRIPTION'
          | translate
      }}
    </vi-text>
  </div>
</div>
